import * as React from 'react'
import { useCallback, useMemo } from 'react'
import { CreateNewLocationCardProps } from './typings'
import { SmallLocationCard, EditCardFooter } from '../../SmallLocationCard'

export const CreateNewLocationCard: React.FC<CreateNewLocationCardProps> = (
  props,
) => {
  const {
    formDispatch,
    disableEdit,
    location,
    location: { id, isInvalid, branch },
    openStates,
    toggleOpenState,
  } = props

  const open = useMemo(() => openStates.has(id), [id, openStates])

  const toggleOpen = useCallback(
    () => toggleOpenState(id),
    [id, toggleOpenState],
  )

  const onClick = useCallback(
    () => formDispatch({ type: 'edit', payload: location }),
    [formDispatch, location],
  )

  return (
    <SmallLocationCard
      {...props}
      isEditable={false}
      open={open}
      toggleOpen={toggleOpen}
      footer={
        <EditCardFooter
          onClick={onClick}
          disabled={disableEdit}
          isInvalid={isInvalid}
          branch={branch ?? ''}
        />
      }
    />
  )
}
CreateNewLocationCard.displayName = 'CreateNewLocationCard'
